import { VideoIconButton } from './VideoPopup';

export function SectionTitle({ label, meta, video, onPlay }) {
  return (
    <div className="section-title">
      <span className="st-titlewrap">{label}</span>
      <span className="st-metawrap">
        {meta != null && <span className="mono">{meta}</span>}
        {video && onPlay && (
          <VideoIconButton label={`Watch: ${video.title}`} onClick={() => onPlay(video)} />
        )}
      </span>
    </div>
  );
}

export default SectionTitle;
